module.exports = __webpack_public_path__ + "static/media/be.09ded67e.png";